import sectionLink from '@sections/link'
import abstract from './abstract'

export default class extends abstract {
  getComponent () {
    return sectionLink
  }

  get headline () {
    return this.item.properties.titel
  }

  get body () {
    return this.item.properties.tekst
  }

  get href () {
    return this.item.properties.linkTil
  }

  get route () {
    return this.item.properties.linkTilIntern.url
  }

  get cta () {
    return this.item.properties.linkTekst
  }
}



// WEBPACK FOOTER //
// ./src/models/sections/link.js